/*پالایشگاه*/
import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={85.637}
      height={84.855}
      viewBox="0 0 85.637 84.855"
      {...props}
    >
      <g data-name="005---Factory-">
        <g transform="translate(1.427 1.44)">
          <path
            d="M54.936 33.331l-12.117 7.265v-6.035a1.427 1.427 0 00-2.155-1.227l-12.118 7.262v-6.035a1.427 1.427 0 00-2.155-1.227l-12.118 7.262v-6.035a1.427 1.427 0 00-2.155-1.227L0 40.596v2.855h57.092v-8.89a1.427 1.427 0 00-2.155-1.227z"
            fill="#0377bc"
          />
          <path
            data-name="Shape"
            d="M35.754 1.845a9.9 9.9 0 011.327-.214l-.186.528c-.029-.014-.071-.029-.1-.043a8.583 8.583 0 00-1.041-.271z"
            fill="#607d8b"
          />
          <path
            data-name="Shape"
            d="M68.51 2.043A10.175 10.175 0 0060.232.232l-.871.171a14.9 14.9 0 00-3.697 1.34l-.328.3a8.9 8.9 0 00-2.027-1.14 13.559 13.559 0 00-6.935-.699 12.387 12.387 0 00-1.27.2 18.364 18.364 0 00-3.711 1.156l-.214.6c-.029-.014-.071-.029-.1-.043a10.8 10.8 0 00-4-.485l-.186.528c-.029-.014-.071-.029-.1-.043a8.583 8.583 0 00-1.039-.274 7.29 7.29 0 00-2.284.942 7.964 7.964 0 00-3.154 8.892 6.839 6.839 0 005.409 4.41l-.043.243s0 7.136 11.418 7.136l.086-.057a6.741 6.741 0 002.569 2.034 8.4 8.4 0 002.212.685 12.211 12.211 0 002.269.2 10.227 10.227 0 008.706-4.867l8.423-13.692a7.939 7.939 0 00-2.855-5.726z"
            fill="#607d8b"
          />
          <path
            data-name="Shape"
            d="M66.569 8.61l-7.907 12.842a10.264 10.264 0 01-6.694 4.667 8.4 8.4 0 01-2.212-.685 6.741 6.741 0 01-2.569-2.027l-.086.057c-11.418 0-11.418-7.136-11.418-7.136l.043-.243a6.839 6.839 0 01-5.409-4.41 7.964 7.964 0 013.157-8.888 7.29 7.29 0 012.284-.942 8.583 8.583 0 011.042.271c.029.014.071.029.1.043l.186-.528a10.8 10.8 0 014 .485c.029.014.071.029.1.043l.214-.6A18.364 18.364 0 0145.103.403a12.387 12.387 0 011.27-.2 13.559 13.559 0 016.937.7 8.9 8.9 0 012.027 1.142l.328-.3a14.9 14.9 0 013.7-1.342l.867-.171a8.421 8.421 0 014 1.813 8.157 8.157 0 012.722 4.539 2.881 2.881 0 01-.385 2.026z"
            fill="#cfd8dc"
          />
          <path
            data-name="Shape"
            d="M74.219 15.218v6.822h-8.564v-6.822a1.748 1.748 0 011.741-1.741h5.081a1.748 1.748 0 011.742 1.741z"
            fill="#37474f"
          />
          <path
            data-name="Shape"
            d="M78.5 52.014H61.373l3.911-29.973.371-2.855h8.564z"
            fill="#37474f"
          />
          <path
            data-name="Shape"
            d="M69.937 15.218v6.822h-4.653l.371-2.855v-3.967a1.748 1.748 0 011.741-1.741h.8a1.748 1.748 0 011.741 1.741z"
            fill="#607d8b"
          />
          <path
            data-name="Shape"
            d="M74.219 52.014H61.373l3.911-29.973.371-2.855h4.282l.371 2.855z"
            fill="#607d8b"
          />
          <path
            data-name="Shape"
            d="M82.783 52.057v25.648H54.237V50.587h27.076a1.469 1.469 0 011.47 1.47z"
            fill="#1566c0"
          />
          <path
            data-name="Shape"
            d="M78.501 52.057v25.648H54.237V50.587h22.794a1.469 1.469 0 011.47 1.47z"
            fill="#2296f3"
          />
          <path fill="#0377bc" d="M0 40.596h57.092v37.109H0z" />
          <path
            data-name="Rectangle-path"
            fill="#02a9f4"
            d="M0 40.596h52.81v37.109H0z"
          />
          <rect
            data-name="Rectangle-path"
            width={9.991}
            height={8.564}
            rx={1}
            transform="translate(5.709 57.723)"
            fill="#fff"
          />
          <rect
            data-name="Rectangle-path"
            width={9.991}
            height={8.564}
            rx={1}
            transform="translate(21.409 57.723)"
            fill="#fff"
          />
          <path
            data-name="Shape"
            d="M51.382 54.958v22.747H37.109V54.958a1.479 1.479 0 011.427-1.517h11.419a1.479 1.479 0 011.427 1.517z"
            fill="#607d8b"
          />
          <path
            data-name="Shape"
            d="M67.082 66.287h5.709a1.427 1.427 0 011.427 1.427v8.564h-8.563v-8.564a1.427 1.427 0 011.427-1.427z"
            fill="#ffeb3a"
          />
          <path
            data-name="Shape"
            d="M82.783 76.278v4.282a1.427 1.427 0 01-1.427 1.427H1.427A1.427 1.427 0 010 80.56v-4.282z"
            fill="#fdd834"
          />
          <path
            data-name="Shape"
            d="M78.5 76.278v4.282a1.427 1.427 0 01-1.427 1.427H1.427A1.427 1.427 0 010 80.56v-4.282z"
            fill="#ffeb3a"
          />
        </g>
        <path
          data-name="Shape"
          d="M2.855 84.854h79.928a2.855 2.855 0 002.855-2.855V52.027a1.427 1.427 0 00-1.427-1.427h-3.037l-4.1-30.074v-5.609a1.427 1.427 0 00-1.428-1.427h-8.563a1.427 1.427 0 00-1.427 1.427v5.614l-4.1 30.069h-1.61V33.472a1.427 1.427 0 00-2.162-1.223l-12.111 7.266v-6.043a1.427 1.427 0 00-2.162-1.223L31.4 39.515v-6.043a1.427 1.427 0 00-2.162-1.223L22.1 36.531a1.427 1.427 0 001.47 2.446l4.976-2.987v4.616H17.127v-7.134a1.427 1.427 0 00-2.162-1.223L.692 40.813a1.315 1.315 0 00-.123.111 1.4 1.4 0 00-.214.2 1.313 1.313 0 00-.151.224 1.327 1.327 0 00-.113.241 1.312 1.312 0 00-.059.285 1.264 1.264 0 00-.032.162V82a2.855 2.855 0 002.855 2.855zm54.237-41.391V76.29h-2.855V56.309a2.855 2.855 0 00-2.855-2.855H39.964a2.855 2.855 0 00-2.855 2.855V76.29H2.855V50.599h9.991a1.427 1.427 0 000-2.855H2.855v-4.281zM39.964 73.436H47.1a1.427 1.427 0 100-2.855h-7.136v-2.854H47.1a1.427 1.427 0 100-2.855h-7.136v-2.854H47.1a1.427 1.427 0 000-2.855h-7.136v-2.854h11.418V76.29H39.964zM82.783 82H2.855v-2.855h79.928zm-8.564-5.71H68.51v-7.136h5.709zM68.51 16.345h5.709V19.2H68.51zm-.181 5.709H74.4L78.292 50.6H64.436zm14.454 31.4V76.29h-5.709v-7.136a2.855 2.855 0 00-2.855-2.855H68.51a2.855 2.855 0 00-2.855 2.855v7.136h-5.709v-15.7h5.709a1.427 1.427 0 100-2.855h-5.709v-4.281zM57.092 40.608H49.4l7.692-4.618zm-14.273 0h-7.693l7.693-4.618zm-28.546 0H6.58l7.693-4.618z"
        />
        <path
          data-name="Shape"
          d="M18.554 50.6h15.7a1.427 1.427 0 000-2.855h-15.7a1.427 1.427 0 100 2.855zM5.709 60.591V66.3a2.855 2.855 0 002.855 2.855H15.7a2.855 2.855 0 002.855-2.855v-5.709a2.855 2.855 0 00-2.855-2.855H8.564a2.855 2.855 0 00-2.855 2.855zM15.7 66.3H8.564v-5.709H15.7zM31.4 57.736h-7.136a2.855 2.855 0 00-2.855 2.855V66.3a2.855 2.855 0 002.855 2.855H31.4a2.855 2.855 0 002.855-2.855v-5.709a2.855 2.855 0 00-2.855-2.855zM24.264 66.3v-5.709H31.4V66.3zM71.364 60.591H78.5a1.427 1.427 0 000-2.855h-7.136a1.427 1.427 0 000 2.855zM35.78 18.599c.393 2.108 2.386 7.512 12.2 7.714a10.04 10.04 0 007.68 2.877l1.52-.921a1.427 1.427 0 001.335.921h1.864l-2.359-1.427 2.359-1.427h-1.861a1.427 1.427 0 00-1.335.921l-1.52-.921c-6.851 0-7.128-5.123-7.136-5.716a1.428 1.428 0 00-2.855.007 8.277 8.277 0 00.5 2.719c-4.893-.537-6.664-2.7-7.288-4.182.217.011.44.036.649.036a1.427 1.427 0 100-2.855c-2.449 0-5.6-.953-6.436-3.644a6.524 6.524 0 012.572-7.265 7.726 7.726 0 016.4-.522 17.958 17.958 0 012.942 1.273 1.427 1.427 0 001.338-2.52c-.143-.076-.273-.128-.412-.2.294-.076.581-.164.879-.224 2.151-.428 6.19-.8 9.086 1.38a6.243 6.243 0 012.616 4.629 1.427 1.427 0 001.427 1.386h.041a1.427 1.427 0 001.383-1.471 8.7 8.7 0 00-2.189-5.348 13.466 13.466 0 011.915-.581c1.877-.411 5.4-.782 7.917 1.343a6.467 6.467 0 012.348 4.663 1.427 1.427 0 001.427 1.392h.036a1.427 1.427 0 001.396-1.463 9.37 9.37 0 00-3.36-6.774A11.829 11.829 0 0060.489.452a16.025 16.025 0 00-3.737 1.332A14.764 14.764 0 0046.255.444a19.754 19.754 0 00-4.006 1.247 1.428 1.428 0 00-.335.234 10.359 10.359 0 00-7.777 1.1 9.336 9.336 0 00-3.768 10.518 7.837 7.837 0 005.411 5.056z"
        />
      </g>
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
